<!--
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-02-28 11:33:45
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2022-08-16 14:19:55
-->
<template>
	<div>
		<el-dialog title="重新分配" width="520px" :visible.sync="dialogVisible" @before-close="handleClose">
			<p class="yx-color-text-primary mb-20 ml-10 fz-16">有合作进度的商品，相应的合作进度也会更换为重新分配的负责人</p>
			<el-form :model="disFrom" ref="disFrom" :rules="disRules">
				<el-form-item :label="zsName" label-width="80px" prop="user_id">
					<zs-partner-select style="width: 240px" v-model="disFrom.user_id" :onlyOnState="true"></zs-partner-select>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="handleClose">取 消</el-button>
				<el-button type="primary" :loading="loading" @click="checkRule">确 定</el-button>
			</div>
		</el-dialog>
		<collision-reminder ref="collisionReminder" @submit="sumbit" />
	</div>
</template>
<script>
import { againAllot, getNewShopUser } from '@/api/shopManage';
import ZsPartnerSelect from '@/components/zsPartnerSelect';
import { zsRoleType } from '@/utils/dataMap';
import collisionReminder from '@/components/business/collisionReminder/collisionReminder.vue';
import { getProductConfig } from '@/api/settings.js';
import { PLATFORM_DY } from '@/utils/dataMap';

export default {
	props: {
		platformId: {
			type: [Number, String],
			default: PLATFORM_DY.value,
		},
	},
	data() {
		const zsName = zsRoleType.name;
		return {
			dialogVisible: false,
			disFrom: {
				product_ids: '',
				user_id: '',
			},
			disRules: {
				user_id: { required: true, message: `请选择${zsName}`, target: 'blur' },
			},
			operatingArr: [],
			list: [],
			productDuplicateAloneState: false,
			getNewShopUserState: 0,
			loading: false,
		};
	},
	computed: {
		zsName() {
			return zsRoleType.name;
		},
	},
	methods: {
		show(row) {
			this.disFrom.user_id = row.user_id;
			this.disFrom.product_ids = row.product_id;
			this.dialogVisible = true;
			this.list = [row];
			this.getConfig();
		},
		// 判断选择的商品是否有跟进人
		async formatFollow() {
			const { code, data } = await getNewShopUser({
				shopUserList: this.list.map(val => {
					return {
						shopId: val.shop_id,
						userId: this.disFrom.user_id,
					};
				}),
				platformId: this.platformId,
			});
			if (code === 0) {
				return data.canAllocate;
			}
		},
		// 判断是否开启跟进人 配置
		async getConfig() {
			const { data, code } = await getProductConfig({ platformId: this.platformId });
			if (code === 0) {
				this.productDuplicateAloneState = data.productDuplicateAlone;
			}
		},
		// 判断如果是快手平台或者后端如果未开启跟进配置或者已经开启了但是选中的商品的跟进人是一样的 走之前的流程
		async checkRule() {
			this.$refs.disFrom.validate(async valid => {
				if (!valid) return;
				this.getNewShopUserState = (await this.formatFollow()) || 0;
				if (!this.productDuplicateAloneState) {
					this.confirm();
					return;
				}
				if (this.productDuplicateAloneState && this.getNewShopUserState) {
					this.confirm();
					return;
				}
				this.$refs.collisionReminder.show(this.list, this.disFrom.user_id);
			});
		},
		sumbit(obj) {
			this.disFrom.product_ids = obj.product_ids;
			this.disFrom.shopDuplicateType = obj.radioValue;
			this.confirm();
		},
		handleClose() {
			this.dialogVisible = false;
			this.operatingArr = [];
			this.disFrom = {
				product_ids: '',
				user_id: '',
			};
			this.$refs.disFrom.resetFields();
		},
		async confirm() {
			if (this.loading) return;
			this.loading = true;
			try {
				this.disFrom.platform_id = this.platformId;
				const { code } = await againAllot(this.disFrom);
				if (code !== 0) return;
				this.$message.success('重新分配成功');
				this.productDuplicateAloneState && !this.getNewShopUserState && this.$refs.collisionReminder.handleClose();
				this.handleClose();
				this.$emit('refreshList');
			} finally {
				this.loading = false;
			}
		},
	},
	components: {
		ZsPartnerSelect,
		collisionReminder,
	},
};
</script>

<style lang="less" scoped>
/deep/ .el-select--small {
	width: 100%;
}
</style>
